import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Home',
    url: '/home/dashboard',
    iconComponent: { name: 'cil-home' },
     class:'333',	
  },
  {
    name: 'Products',
    url: '/product/product-dashboard',
    iconComponent: { name: 'cil-star' },   
  },  
  {
    name: 'Report',
    url: '/report/report-dashboard',
    iconComponent: { name: 'cil-chart' },   
  },  
  {
    name: 'Reward',
    url: '/reward/reward-dashboard',
    iconComponent: { name: 'cilBadge' },
   
  }, 
{
    name: 'Support',
    url: '/support/support-dashboard',
    iconComponent: { name: 'cilContact' },
   
  },     
];
